import React from 'react';
import { Building2 } from 'lucide-react';

const Watermark = () => {
  return (
    <div className="absolute bottom-4 right-4 bg-gradient-to-r from-blue-900/90 to-blue-800/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
      <Building2 className="text-amber-400" size={20} />
      <div className="text-white">
        <p className="text-xs font-bold leading-tight">FD-Inmobiliaria</p>
        <p className="text-[10px] text-amber-400 leading-tight">Real Estate Services</p>
      </div>
    </div>
  );
};

export default Watermark;
